<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep3ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 금리 안내(보통예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6></h6>
      <div class="tbl-top-etc">{{/*(연이율, 세전, 단위 : %)*/$t("MDEP-01-02-03-07")}}</div>
    </div>
    <table class="table -type02">
      <thead>
        <tr>
          <th scope="col">{{/*기간*/$t("MDEP-01-02-03-06") }}</th>
          <th scope="col">USD</th>
          <th scope="col">KHR</th>
          <th scope="col">{{/*금리구분*/$t("MDEP-01-02-03-15") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>-</td>
          <td>0.50</td>
          <td>0.70</td>
          <td>{{/*확정금리*/$t("MDEP-01-02-03-16") }}</td>
        </tr>
      </tbody>
    </table>
    <div class="info info-etc">· {{/*영업점 내점상담 후, 금리 결정*/$t("MDEP-01-02-03-17")}}</div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      currentTab: 2,
    };
  },
};
</script>